import { FormattedMessage, useIntl } from "react-intl";
import { Symptom } from "../../../../api/index.defs";
import MetaCard from "../MetaCard/MetaCard";
import TextDirAligner from "../../../Shared/TextDirAligner/TextDirAligner";

type SymptomsProps = {
  symptoms?: Symptom[];
  compare?: boolean;
};

const Symptoms = ({ symptoms, compare }: SymptomsProps) => {
  const intl = useIntl();
  const symptomsText =
    symptoms
      ?.map((s) => s.symptomName)
      .join(", ")
      .replace(/, ([^,]*)$/, ", $1.") ||
    intl.formatMessage({
      id: "ECG_DETAILS.SYMPTOMS.NO_SYMPTOMS",
      defaultMessage: "No Symptoms",
    });

  return (
    <MetaCard compare={compare}>
      <div className="font-md">
        <p className="mb-0 prim-color-dark font-weight-bold">
          <FormattedMessage
            id="ECG_DETAILS.SYMPTOMS"
            defaultMessage="Reported Symptoms"
          />
        </p>
        <TextDirAligner className="mt-2 mb-0">{symptomsText}</TextDirAligner>
      </div>
    </MetaCard>
  );
};

export default Symptoms;
